import React from 'react';

import Loader from 'components/Loader';

import styles from './VideoWithPreview.module.css';

interface VideoWithPreviewProps {
    videoLoaded: boolean;
    previewImage: string;
    previewClasses?: string;
    videoClasses?: string;
    handleVideoLoad: () => void;
    videoLink: string;
}

const VideoWithPreview = ({
    videoLoaded,
    previewImage,
    previewClasses,
    videoClasses,
    handleVideoLoad,
    videoLink,
}: VideoWithPreviewProps) => {
    return (
        <>
            {!videoLoaded && (
                <>
                    <img src={previewImage} alt="preview" className={previewClasses} />
                    <div className={styles.overlay}>
                        <Loader isLoading additionalClass={styles.overlayLoader} />
                    </div>
                </>
            )}
            <video muted autoPlay loop className={videoClasses} playsInline onCanPlayThrough={handleVideoLoad}>
                <source src={videoLink} type="video/mp4" />
            </video>
        </>
    );
};

export default VideoWithPreview;
